import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=2322ede0&"
import script from "./CatalogList.vue?vue&type=script&lang=js&"
export * from "./CatalogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiFilter: require('/app/components/UI/UiFilter.vue').default})
